import { render, staticRenderFns } from "./IllinoisMyBets.vue?vue&type=template&id=4167968e"
import script from "./IllinoisMyBets.vue?vue&type=script&lang=ts"
export * from "./IllinoisMyBets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports